<style lang="scss" scoped>
  .product-image {
    min-height: 300px;
    background-size: cover;
    background-position: center center;
  }

  .loading-overlay {
    background-color: rgba(255,255,255,0.8);
    display: flex;
    position: absolute;
    padding: 30px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }

  .cart-table {
    width: 100%;

    .cell-image {
      width: 120px;
    }

    .cell-actions {
      width: 120px;
    }
  }
</style>

<template>
  <div>
    <div v-if="$root.$data.cart">
      <div class="px2 mb3">
        <md-button class="md-raised md-primary right" @click="goToCheckout()" :disabled="$root.$data.cart.items.length == 0">Gå til kassen</md-button>
        <md-button class="md-raised right" @click="goBack()">Tilbake</md-button>
        <div class="fz24 light mt2">Handlekurv</div>
        <p class="mt2 mb2">Du har {{ $root.$data.cart.items.length }} varer i handlekurven.</p>
      </div>
      <div>
        <div class="clearfix relative">
          <div class="loading-overlay" v-if="state.is('emptying-cart')">
            <md-spinner md-indeterminate></md-spinner>
          </div>
          <div class="card rounded sh1" v-if="$root.$data.cart.items.length > 0">

            <table class="cart-table" cellpadding="0" cellspacing="0">
              <thead>
              <tr class="text-grey ">
                <th class="border-bottom border-light-grey "></th>
                <th class="border-bottom border-light-grey py2 light left-align">Produkt</th>
                <th class="border-bottom border-light-grey py2 light">Antall</th>
                <th class="border-bottom border-light-grey py2 light left-align">Pris pr. stk.</th>
                <th class="border-bottom border-light-grey py2 light left-align" light>Total</th>
                <th class="border-bottom border-light-grey py2 light">Handlinger</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(cartItem, index) in $root.$data.cart.items" class="@bg-light-blue">
                <td class="cell-image p2">
                  <img class="rounded pointer" :src="getThumbnail(cartItem.product)" width="80" height="80"
                       @click="viewProduct(cartItem.product.id)" />
                </td>
                <td>
                  <div class="fz18 mb1 text-blue pointer" @click="viewProduct(cartItem.product.id)">{{ cartItem.product.name }}</div>
                  <div>{{ cartItem.parameters_text }}</div>
                </td>
                <td>
                  <myo-input v-model="cartItem.quantity" @change.native="updateItem(index)" class="center"></myo-input>
                </td>
                <td>
                  <div class="fz24 light text-grey truncate">kr {{ toLocale(cartItem.unit_price / 100) }},-</div>
                </td>
                <td>
                  <div class="fz24 light text-blue truncate">kr {{ toLocale(cartItem.total / 100) }},-</div>
                </td>
                <td class="cell-actions center">
                  <md-button class="md-icon-button" @click.native="removeItem(index)">
                    <md-icon>close</md-icon>
                  </md-button>
                </td>
              </tr>
              </tbody>
            </table>

            <div class="clearfix flex border-top border-light-grey">
              <div class="flex-auto p1">
                <md-button class="" @click.native="emptyCart()">Tøm handlekurven</md-button>
              </div>
              <div class="p3">
                <div class="fz24 light mb1 text-grey truncate">kr {{ toLocale($root.$data.cart.net_total / 100) }},-</div>
                <div class="text-grey">Total eksl. MVA</div>
              </div>
              <div class="p3">
                <div class="fz24 light mb1 text-grey truncate">kr {{ toLocale($root.$data.cart.vat_total / 100) }},-</div>
                <div class="text-grey">MVA</div>
              </div>
              <div class="p3">
                <div class="fz24 light mb1 text-blue truncate">kr {{ toLocale($root.$data.cart.gross_total / 100) }},-</div>
                <div class="text-grey">Total inkl. MVA</div>
              </div>
            </div>
          </div>
          <div class="card rounded sh1" v-if="$root.$data.cart.items.length == 0">
            <div class="p3 center">
              <div class="fz24 light my3">Ingen varer i handlekurven...</div>
              <md-button class="md-raised md-primary" @click.native="goToShop()">Klikk her for å handle</md-button>
            </div>
          </div>
        </div>
      </div>
      <div class="px2 my3">
        <md-button class="md-raised md-primary right" @click="goToCheckout()" :disabled="$root.$data.cart.items.length == 0">Gå til kassen</md-button>
        <md-button class="md-raised right" @click="goBack()">Tilbake</md-button>
        <div class="fz24 light mt2">Handlekurv</div>
        <p class="mt2 mb2">Du har {{ $root.$data.cart.items.length }} varer i handlekurven.</p>
      </div>
    </div>
    <div class="p3 center" v-else>
      <md-spinner md-indeterminate></md-spinner>
    </div>
  </div>
</template>

<script>
  import apiCart from '@/js/api/cart';
  import apiCartItem from '@/js/api/cartItem';
  import State from '@/js/helpers/state';
  import hasPrices from '@/js/mixins/hasPrices';
  import hasPictures from '@/js/mixins/hasPictures';

  export default {
    mixins: [hasPrices, hasPictures],

    data() {
      return {
        state: new State(),
        cart: null,
      };
    },

    mounted() {
      // this.state.start('loading');
      apiCart.get().then(this.onCartSuccess);
    },

    methods: {
      onCartSuccess(cart) {
        apiCart.show(cart.id).then(this.onFetchSuccess);
      },

      onFetchSuccess(response) {
        this.$root.$data.cart = response.data.data;
        // this.state.stop('loading');
      },

      removeItem(index) {
        const item = this.$root.$data.cart.items[index];

        return apiCartItem.remove(item.id).then((response) => {
          this.$root.$data.cart.items.splice(index, 1);

          const newTotals = response.data.meta.cart_totals;

          this.$root.$data.cart.gross_total = newTotals.gross_total;
          this.$root.$data.cart.vat_totals = newTotals.vat_totals;
          this.$root.$data.cart.net_totals = newTotals.net_totals;
        });
      },

      updateItem(index) {
        const item = this.$root.$data.cart.items[index];

        if (item.quantity === 0) {
          this.removeItem(index);
        } else {
          const data = {
            quantity: item.quantity,
          };

          apiCartItem.update(item.id, data).then(this.onItemUpdateSuccess);
        }
      },

      onItemUpdateSuccess(response) {
        apiCart.refresh().then((cart) => {
          this.$root.$data.cart = cart;
        });
      },

      viewProduct(id) {
        this.$router.push({ name: 'view-product', params: { productId: id } });
      },

      goToCheckout() {
        this.$router.push({ name: 'checkout' });
      },

      goToShop() {
        this.$router.push({ name: 'shop' });
      },

      goBack() {
        this.$router.go(-1);
      },

      emptyCart() {
        this.state.start('emptying-cart');
        const count = this.$root.$data.cart.items.length - 1;

        this.removeItem(count).then(() => {
          if (count > 0) {
            this.emptyCart();
          } else {
            this.state.stop('emptying-cart');
          }
        });
      },

      getProductImage(product) {
        return `background-image: url('${product.image_url}')`;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Cart.vue?320115f8